import { NgModule } from '@angular/core';
import { WithdrawalECheckPage } from './withdrawal-echeck';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
@NgModule({
  declarations: [
    WithdrawalECheckPage,
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule
  ],
})
export class WithdrawalECheckPageModule {}
